export const getAppLogMetricsFromPastWeek = (appLogs: any) => {
  // get total sessions
  let totalSessions = 0;
  let avgTimeForWeek = 0;

  // Note her we need to add weighted avg
  appLogs?.forEach((log: { totalClaims: number; avgProofTime: number }) => {
    totalSessions += log.totalClaims;
    avgTimeForWeek += log.avgProofTime * log.totalClaims;
  });

  avgTimeForWeek = avgTimeForWeek / totalSessions;

  return {
    totalSessions,
    avgTimeForWeek,
  };
};
